import React from 'react';
import { createPortal } from 'react-dom';

export default function PaidForDateExplainer({
  open,
  onClose,
  signedIn = true,
  onSignUp,
  onGetPaidForDate,
}) {
  if (!open) return null;

  const handlePrimaryAction = () => {
    onClose();
    if (!signedIn && typeof onSignUp === 'function') {
      onSignUp();
      return;
    }
    if (typeof onGetPaidForDate === 'function') onGetPaidForDate();
  };

  const primaryLabel = signedIn ? 'GET A PAID-FOR DATE' : 'SIGN UP';

  return createPortal(
    <div
      className="cart-popup-overlay vibe-popup-overlay paid-for-date-explainer-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="cart-popup vibe-popup paid-for-date-explainer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="paid-for-date-explainer-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="cart-popup-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>
        <h3 id="paid-for-date-explainer-title" className="cart-popup-title vibe-popup-dinner-title">
          WIN A PAID-FOR DATE
        </h3>
        <p className="vibe-popup-text">
          Complete a streak of five vibe checks and win a date experience.
        </p>
        <p className="vibe-popup-text">
          Vibe checks are easy. Just send one daily GIF to Vibe Fox.
        </p>
        <button type="button" className="vibe-popup-btn" onClick={handlePrimaryAction}>
          {primaryLabel}
        </button>
      </div>
    </div>,
    document.body,
  );
}
